import {Redirect_Admin} from "./shared/utils";

export default {
    items: {
        header: {
            title: true,
            name: 'Auftragsbuch',
            class: ''
        },
        header_av: {
            title: true,
            name: 'Aufgabenverwaltung',
            class: ''
        },
        inbox: {
            name: 'Posteingang',
            url: '/inbox/messages',
            icon: 'fa fa-inbox fa-md',
        },
        chat: {
            name: 'Chats',
            url: '/chats/chat',
            icon: 'fa fa-comments fa-md',
        },
        anfragen: {
            name: 'Anfragen',
            url: '/base',
            icon: 'fa fa-envelope-o fa-md',
            open: true,
            children: [
                {
                    name: 'Posteingang',
                    url: '/anfragen/offen',
                },
                {
                    name: 'Alle',
                    url: '/anfragen/alle',
                },
                {
                    name: 'In Bearbeitung',
                    url: '/anfragen/in_bearbeitung',
                },
                {
                    name: 'Fertiggestellt',
                    url: '/anfragen/fertig',
                },
                {
                    name: 'Abgelehnt',
                    url: '/anfragen/abgelehnt',
                },
            ]
        },
        aufgaben: {
            name: 'Meine Aufgaben',
            url: '/base',
            icon: 'fa fa-tasks fa-md',
            open: true,
            children: [
                /*{
                    name: 'Offen',
                    url: '/aufgaben/offen',
                },*/
                {
                    name: 'Aufgabenverwaltung',
                    url: '/aufgaben/verwaltung',
                },
                {
                    name: 'Abgelehnt',
                    url: '/aufgaben/abgelehnt',
                },
            ]
        },
        aufgaben_bh: {
            name: 'Meine Aufgaben',
            url: '/base',
            icon: 'fa fa-tasks fa-md',
            open: true,
            children: [
                {
                    name: 'Aufgabenverwaltung',
                    url: '/aufgaben/verwaltung',
                },
                {
                    name: 'Einzelauftrag anlegen',
                    url: '/e_create?einzel=true&is_bauhof=true',
                },
                {
                    name: 'Aufgabe anlegen',
                    url: '/create?is_bauhof=true',
                },
                {
                    name: 'Abgelehnt',
                    url: '/aufgaben/abgelehnt',
                },
            ]
        },
        aufgaben_from_me:
            {
                name: 'Gestellte Aufgaben',
                url: '/base',
                icon: 'fa fa-briefcase fa-md',
                open: true,
                children: [
                    {
                        name: 'Erteilen',
                        url: '/create',
                    },
                    {
                        name: 'Alle',
                        url: '/aufgaben_m/alle',
                    }
                    ,
                    {
                        name: 'Offen',
                        url: '/aufgaben_m/offen',
                    },
                    {
                        name: 'Fertiggestellt',
                        url: '/aufgaben_m/fertig',
                    },
                    {
                        name: 'Rechnung',
                        url: '/aufgaben_m/rechnung',
                    },
                    {
                        name: 'Abgelehnt',
                        url: '/aufgaben_m/abgelehnt',
                    },
                    {
                        name: 'Sammelrechnungen',
                        url: '/aufgaben_m/rechnung_sammel',
                    }
                ]
            },
        angebote: {
            name: 'Angebote',
            url: '/base',
            icon: 'fa fa-exchange fa-md',
            children: [
                {
                    name: 'Alle',
                    url: '/base/breadcrumbs',
                },
                {
                    name: 'Offen',
                    url: '/base/cards',
                },
                {
                    name: 'Abgelehnt',
                    url: '/base/carousels',
                }
            ]
        },
        auftraege:
        {
            name: 'Aufträge',
            url: '/base',
            icon: 'fa fa-briefcase fa-md',
            open: true,
            children: [
                {
                    name: 'Erteilen',
                    url: '/create',
                },
                {
                    name: 'Alle',
                    url: '/auftraege/alle',
                }
                ,
                {
                    name: 'Offen',
                    url: '/auftraege/offen',
                },
                {
                    name: 'Fertiggestellt',
                    url: '/auftraege/fertig',
                },
                {
                    name: 'Rechnung',
                    url: '/auftraege/rechnung',
                },
                {
                    name: 'Abgelehnt',
                    url: '/auftraege/abgelehnt',
                },
                {
                    name: 'Sammelrechnungen',
                    url: '/auftraege/rechnung_sammel',
                }
            ]
        },
        stamm: {
            name: 'Stammaufträge',
            url: '/stamm/auftraege',
            icon: 'fa fa-database fa-md',
        },
        geo_referencing: {
            name: 'Georeferenzierung',
            url: '/geo_referencing/reference',
            icon: 'fa fa-map fa-md',
        },
        touren_pro: {
            name: 'Tourenplanung',
            url: '/base',
            icon: 'fa fa-compass fa-md',
            open: true,
            children: [
                {
                    name: 'Straßen Import',
                    url: '/touren_pro/import/streets',
                },
            ]
        },
        planning: {
            name: 'Planung',
            url: '/planning/planning',
            icon: 'fa fa-compass fa-md',
        },
        series: {
            name: 'Aufgabenserien',
            url: '/aufgaben/task_series',
        },
        predefined_tours: {
            name: 'Vorgefertigte Touren',
            url: '/aufgaben/predefined_tours',
        },
        footer: {
            class: 'mt-auto',
            name: 'Administration',
            icon: 'icon-wrench',
            variant: 'secondary',
            url:Redirect_Admin
        },
},
    items_dummy: {
        header: {
            title: true,
            name: 'Auftragsbuch',
            class: ''
        },
        inbox: {
            name: 'Posteingang',
            icon: 'fa fa-inbox fa-md',
        },
        chat: {
            name: 'Chats',
            icon: 'fa fa-comments fa-md',
        },
        auftraege:
        {
            name: 'Aufträge',
            icon: 'fa fa-briefcase fa-md',
            open: true,
            children: [
                {
                    name: 'Erteilen',
                },
                {
                    name: 'Alle',
                }
                ,
                {
                    name: 'Offen',
                },
                {
                    name: 'Fertiggestellt',
                },
                {
                    name: 'Rechnung',
                },
                {
                    name: 'Abgelehnt',
                },
                {
                    name: 'Sammelrechnungen',
                }
            ]
        },
        footer: {
            class: 'mt-auto',
            name: 'Anmeldung',
            icon: 'icon-wrench',
            variant: 'secondary',
        },
    },
}
